import { useAppSelector } from '_common/hooks/reduxHooks';
import { consumerRoutes } from '_consumer/router';
import { producerRoutes } from '_producer/router';

export const usePageResults = (query: string) => {
  const { role } = useAppSelector(({ auth }) => {
    return {
      role: auth._type
    };
  });

  const routes =
    role === 'producers'
      ? producerRoutes().at(0)?.children
      : role === 'consumers'
        ? consumerRoutes().at(0)?.children
        : null;

  const searchableRoutes = routes?.filter(route => 'title' in route);

  if (!searchableRoutes) {
    return { pageResults: [] };
  }

  if (query === '') {
    return { pageResults: searchableRoutes.map(route => ({ route })) };
  }

  const keywords = query.toLowerCase().split(' ');

  const matches = searchableRoutes.filter(route => {
    const title = route.title?.toLowerCase();
    return keywords.some(keyword => title?.includes(keyword));
  });

  const matchesWithWeight = matches.map(route => {
    const matchCount = keywords.filter(keyword =>
      route.title?.toLowerCase().includes(keyword)
    ).length;
    return {
      route,
      matchCount
    };
  });

  const sortedMatches = matchesWithWeight.sort(
    (a, b) =>
      b.matchCount - a.matchCount ||
      a.route.title!.localeCompare(b.route.title!)
  );
  return { pageResults: sortedMatches };
};
